<template>
    <div class="bg_root">


        <div class="menu-bar">
            <div style="display: flex;flex-direction:row;">

                <el-text class="menu-item" style="margin-left: 130px;color: white;">云南柳叶刀医疗管理有限公司</el-text>
            </div>

            <div style=" margin-right: 140px;">
                <nav>
                   <a class="menu-item" style="margin-right: 100px;" @click="handleAboutClick">|&nbsp;&nbsp;关于我们</a>

                    <a class="menu-item" style="  margin-right: 100px;"
                        @click="handleProductClick">|&nbsp;&nbsp;产品展示</a>

                    <a class="menu-item" style="  margin-right: 100px;" @click="handleAppClick">|&nbsp;&nbsp;看看云医App</a>
                    <a class="menu-item" style="  margin-right: 100px;" @click="handleHonorClick">|&nbsp;&nbsp;资证荣誉</a>
                    <!-- <a class="menu-item"  href="https://www.jiguang.cn/license/privacy?from_wecom=1" target="_blank">|&nbsp;&nbsp;隐私政策</a> -->

                    <router-link to="/privacy" class="menu-item" target="_blank">
                        <span> |&nbsp;&nbsp;隐私政策</span>
                    </router-link>



                </nav>
            </div>

        </div>

        <div style="display: flex; flex-direction: row;padding-top: 10px; justify-content: center;">
            <a class="menu-item2" style="margin-left: 10px;" href="https://beian.miit.gov.cn/" target="_blank">
                ICP备案/许可证号：滇ICP备2024040918号-2
            </a>
            <span class="menu-item2" style="margin-left: 10px;"> | </span>
            <a class="menu-item2" style="margin-left: 10px;" href="https://beian.miit.gov.cn/" target="_blank">
                增值电信业务经营许可证编号：滇B2-20250254
            </a>
            <span class="menu-item2" style="margin-left: 10px;"> | </span>
            <a class="menu-item2" style="margin-left: 10px;" href="https://mpa.yn.gov.cn/Pages/list/xzxk.aspx" target="_blank">
                互联网药品医疗器械信息服务备案：滇网药械信备字〔2025〕000038号
            </a>
            <span class="menu-item2" style="margin-left: 10px;"> | </span>
            <span class="menu-item2" style="margin-left: 10px;">
                信息系统安全等级保护备案证明证书编号：53010013044-25001
            </span>
        </div>


            <div class="center-text">
            <span class="menu-item2" >
                本网站未发布疫苗、血液制品、麻醉药品、精神药品、医疗用毒性药品、放射性药品、药品类易制毒化学品、医疗机构制剂和中药配方颗粒等国家实行特殊管理的产品信息
            </span>
        </div>

        
     <div class="center-text">
            <span class="menu-item2" >
                本公司网站不得发布未经国家批准的药品广告信息
            </span>
        </div>
        
        <div class="center-text">
            <span class="menu-item2" >
                公司地址：云南省昆明市滇池度假区太河社区红塔东路211号1层1号
            </span>
        </div>

        <div class="center-text">
            <span class="menu-item2" style="font-weight: bold;" >
                云南省药品监督管理局联系电话：0871-68315800  |  投诉举报：12315
            </span>
        </div>

    </div>
</template>

<script>


export default {
    setup(props, { emit }) {

        //点击关于我们
        const handleAboutClick = () => {
            emit('about-click');
        };
        //点击产品介绍
        const handleProductClick = () => {
            emit('product-click');
        };
              //点击app
        const handleAppClick = () => {
            emit('app-click');
        };
        //点击资证荣誉
        const handleHonorClick = () => {
            emit('honor-click');
        };

        return {
            handleAboutClick,
            handleProductClick,
            handleAppClick,
            handleHonorClick,
        };


    }
}
</script>

<style scoped>
.bg_root {
    background-color: #0A294D;
    display: flex;
    flex-direction: column;
}

.menu-item {
    display: inline-block;
    font-size: 20px;
    white-space: nowrap;
    color: white;
    opacity: 0.7;
    text-decoration: none;
}

.menu-item2 {
    display: inline-block;
    font-size: 15px;
    white-space: nowrap;
    color: white;
    opacity: 0.7;
    text-decoration: none;
}

.menu-bar {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 47px;
    padding-bottom: 47px;
    top: 0px;
    right: 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.center-text {
  text-align: center;
}
</style>